import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

import { BreadcrumbService } from './breadcrumb.service';

/**
 * Rendered once in app.html, above the router outlet. Pages do not build or
 * place their own trail — the shape of every trail is decided in
 * BreadcrumbService from the route table. See features/navigation.feature.
 */
@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './breadcrumb.html',
  styleUrl: './breadcrumb.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbComponent {
  protected readonly items = inject(BreadcrumbService).items;
}
